import _Reflect$construct from '@babel/runtime-corejs3/core-js/reflect/construct';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import * as React from 'react';
import classNames from 'classnames';
import '../../../../utils/fetcher.js';
import { prependPrefix } from '../../../../utils/style.js';
import { isMobileSlideBar } from '../../../utils/index.js';
import { SlideCheckBar } from '../slide-check-bar/index.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var SlideCheckModal = /*#__PURE__*/function (_React$Component) {
  _inherits(SlideCheckModal, _React$Component);

  var _super = _createSuper(SlideCheckModal);

  function SlideCheckModal() {
    _classCallCheck(this, SlideCheckModal);

    return _super.apply(this, arguments);
  }

  _createClass(SlideCheckModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$darkMode = _this$props.darkMode,
          darkMode = _this$props$darkMode === void 0 ? false : _this$props$darkMode,
          scene = _this$props.scene,
          onSuccess = _this$props.onSuccess,
          onRef = _this$props.onRef,
          onClose = _this$props.onClose;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(prependPrefix('slide-check-modal'), {
          'slide-check-dark-modal': darkMode,
          'slide-check-mobile': isMobileSlideBar()
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: "slide-title"
      }, "\u4E3A\u4E86\u60A8\u7684\u8D26\u53F7\u5B89\u5168\uFF0C\u8BF7\u8FDB\u884C\u9A8C\u8BC1"), /*#__PURE__*/React.createElement("div", {
        className: "slide-check-row"
      }, /*#__PURE__*/React.createElement(SlideCheckBar, {
        width: 260,
        scene: scene || 'nc_message',
        callback: onSuccess,
        onRef: onRef,
        darkMode: darkMode
      })), /*#__PURE__*/React.createElement("div", {
        className: "close-btn",
        onClick: onClose
      }, "\xD7"));
    }
  }]);

  return SlideCheckModal;
}(React.Component);

export { SlideCheckModal };
